import { Link } from "react-router-dom";
import { Frame } from "@/components/site/Frame";

export const ProjectCard = ({ project: p }) => (
  <Link to={`/work/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group block" aria-label={`${p.title} — view case study`}>
    <div className="relative">
      <Frame {...p.cover} innerClass="transition-transform duration-[1400ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.04]" />
      <span className="label absolute left-4 top-4 bg-paper px-2 py-1 text-ink sm:left-5 sm:top-5">{p.tag}</span>
      <span className="label absolute right-4 top-4 hidden overflow-hidden text-paper sm:right-5 sm:top-5 md:block">
        <span className="block translate-y-[110%] bg-ink px-3 py-1.5 transition-transform duration-500 ease-[cubic-bezier(.22,1,.36,1)] group-hover:translate-y-0">View case study →</span>
      </span>
    </div>
    <div className="mt-5 grid grid-cols-[2.5rem_1fr_auto] items-baseline gap-x-3 border-t border-ink pt-4">
      <span className="label text-mute">{p.no}</span>
      <div>
        <h3 className="font-display text-2xl font-medium leading-tight tracking-[-0.03em] lg:text-[1.9rem]">
          <span className="u-link">{p.title}</span>
        </h3>
        <p className="mt-2 text-sm text-mute">{p.category}</p>
        {p.highlight && <p className="label mt-3 text-ink">{p.highlight}</p>}
      </div>
      <span className="text-xl transition-transform duration-500 group-hover:translate-x-1" aria-hidden="true">→</span>
    </div>
  </Link>
);
